import type { ExportRequest, ExportResponse } from "@plenum/shared/api";
import { ApiError } from "./api";

/** Shared handler for export buttons: run the mutation, then open the signed URL. */
export async function runExport(
  mutate: (body: ExportRequest) => Promise<ExportResponse>,
  body: ExportRequest,
  toast: (text: string, tone?: "ok" | "danger" | "muted", href?: string) => void,
): Promise<ExportResponse | null> {
  try {
    const res = await mutate(body);
    toast(
      `Export ready: ${res.rows} rows (${res.format}, ${res.columns}). Link valid 24 h.`,
      "ok",
      res.url,
    );
    window.location.assign(res.url);
    return res;
  } catch (e) {
    toast(e instanceof ApiError ? e.message : "Export failed", "danger");
    return null;
  }
}
